/**
 * The "+N more" / "Show less" toggle a dense Month day cell shows below its
 * visible chips. Split out of `WorkshopsCalendarDayCell` so that file holds
 * one component.
 */
export interface WorkshopsCalendarDayCellMoreToggleProps {
  expanded: boolean;
  hiddenCount: number;
  onToggle: () => void;
}

export function WorkshopsCalendarDayCellMoreToggle({
  expanded,
  hiddenCount,
  onToggle,
}: WorkshopsCalendarDayCellMoreToggleProps) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      style={{
        marginTop: 2,
        width: '100%',
        padding: '3px 6px',
        fontSize: 9.5,
        fontWeight: 700,
        letterSpacing: '.02em',
        color: 'var(--nb-ink)',
        background: 'var(--nb-surface)',
        border: 'none',
        borderLeft: '3px solid var(--nb-faint)',
        borderRadius: 3,
        boxShadow: '0 0 0 1px var(--nb-border)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 4,
      }}
    >
      <span>{expanded ? 'Show less' : `+${hiddenCount} more`}</span>
      <svg
        width="9"
        height="9"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ opacity: 0.6 }}
      >
        {expanded ? <path d="M18 15l-6-6-6 6" /> : <path d="M6 9l6 6 6-6" />}
      </svg>
    </button>
  );
}
